// extracted by mini-css-extract-plugin
export default {"container":"press_container__3b9l5","wrapper":"press_wrapper__iXirU","logodiv":"press_logodiv__rOn9X"};